import { useNavigate } from "react-router-dom";
import { DestinationsData } from "../../utils/destinations";

const TopDest = () => {
  const navigate = useNavigate();

  const handleDestinationClick = (dest: string) => {
    navigate(`/pages/Destinations/${dest}`);
  };

  const redirectToDestinations = () => {
    navigate("/destinations");
  };
  return (
    <div className="container">
      <div className="flex flex-col lg:flex-row md:flex-row justify-between items-center pb-4">
        <h2 className="lg:text-[30px] md:text-[30px] text-[20px] text-center md:text-start lg:text-start font-bold mb-5">
          Top Destinations
        </h2>
        <div className="">
          <button
            className="bg-red-600 text-white px-12 py-2 rounded-lg shadow-lg hover:bg-red-500 transition duration-300 7"
            onClick={redirectToDestinations}
          >
            View All
          </button>
        </div>
      </div>
      <div className="lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 items-center justify-center hidden">
        {DestinationsData?.map((dest, index) => (
          <div
            key={index}
            className="relative group flex items-center flex-shrink-0 text-center border border-gray-700 p-5 lg:mx-0 md:mx-0 mx-5 rounded-lg gap-10 transition transform hover:-translate-y-2 hover:shadow-muted-500 shadow-lg cursor-pointer"
            onClick={() => handleDestinationClick(dest.slug)}
          >
            <div className="w-28 h-28 overflow-hidden rounded-full border-2 border-gray-300">
              <img
                src={dest.image.src}
                alt={dest.image.alt}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="mt-2 text-sm font-medium">{dest.title}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 items-center justify-center lg:hidden px-4">
        {DestinationsData.slice(0, 4).map((dest, index) => (
          <div
            key={index}
            className="relative group flex flex-col items-center flex-shrink-0 text-center border border-gray-700 p-5 rounded-lg gap-4 transition transform hover:-translate-y-2 hover:shadow-muted-500 shadow-lg cursor-pointer"
            onClick={() => handleDestinationClick(dest.slug)}
          >
            <div className="w-28 h-28 overflow-hidden rounded-full border-2 border-gray-300">
              <img
                src={dest.image.src}
                alt={dest.image.alt}
                className="w-full h-full object-cover"
              />
            </div>
            <p className="mt-2 text-sm font-medium">{dest.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopDest;
